import React, { Component } from 'react'
import { connect } from 'react-redux'
import { createStructuredSelector } from 'reselect'
import styled from 'styled-components'

import { setDate } from '../actions'
import { getDate } from '../selectors'

import moment from '../../../../lib/moment'
import bindActionCreators from '../../../../lib/utils/bindActionCreators'

import BaseDatePicker from '../../../../lib/components/DatePicker'

const Root = styled.div`
  display: flex;

  > :first-child {
    margin-right: 6px;
  }

  > :last-child {
    margin-left: 6px;
  }
`

const Text = styled.span`
  display: inline-block;
  padding-top: 2px;
`

const DatePicker = styled(BaseDatePicker)`
  width: 120px;
  padding-left: 0;
  text-align: center;
`

/**
 * @typedef {object} Props
 * @property {{ from: import('moment').Moment, to: import('moment').Moment }} date
 * @property {typeof setDate} setDate
 */

/**
 * @typedef {object} State
 * @property {{ from: import('moment').Moment, to: import('moment').Moment }} date
 */

/** @extends {Component<Props, State>} */
export class DateFilter extends Component {
  /**
   * @param {Props} props
   */
  static getDerivedStateFromProps = props => {
    return props.date
  }

  /** @type {Props} */
  static defaultProps = {
    date: {
      from: moment(),
      to: moment(),
    },
    setDate: () => {},
  }

  state = {
    from: this.props.date.from,
    to: this.props.date.to,
  }

  /** @type {(target: string) => (value: import('moment').Moment) => void} */
  handleDateChange = target => value => this.props.setDate(target, value)

  render = () => {
    const { from, to } = this.state
    return (
      <Root>
        <DatePicker
          showMonthYearPicker
          dateFormat="YYYY-MM-DD"
          selected={ from }
          onChange={ this.handleDateChange('from') }
        />
        <Text>to</Text>
        <DatePicker
          showMonthYearPicker
          dateFormat="YYYY-MM-DD"
          selected={ to }
          onChange={ this.handleDateChange('to') }
        />
      </Root>
    )
  }
}

const mapStateToProps = createStructuredSelector({
  date: getDate,
})

const mapDispatchToProps = bindActionCreators({
  setDate,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(DateFilter)



// WEBPACK FOOTER //
// ./src/pages/report/billing-plan/components/DateFilter.jsx